export enum IModalType {
    default,
    confirm
}
